import { Pipe, PipeTransform } from '@angular/core';

import { Player, User } from '@optical/types';

import { UserInfo } from '../state/auth';

@Pipe({
  name: 'fullName',
})
export class FullNamePipe implements PipeTransform {
  transform(value: Player | null | undefined): string | null;
  transform(value: User | null | undefined): string | null;
  transform(value: UserInfo | null | undefined): string | null;
  transform(value: Player | User | UserInfo | null | undefined): string | null {
    if (value === null || typeof value === 'undefined') {
      return null;
    }

    let firstName: string | undefined;
    let lastName: string | undefined;

    if ('attributes' in value) {
      // Player
      firstName = value.firstName;
      lastName = value.lastName;
    } else if ('enabled' in value) {
      // User
      firstName = value.firstName;
      lastName = value.lastName;
    } else {
      // UserInfo
      firstName = value.givenName;
      lastName = value.familyName;
    }

    if (!firstName && !lastName) {
      return null;
    }

    return [...(firstName ? [firstName] : []), ...(lastName ? [lastName] : [])].join(' ');
  }
}
